import { z } from 'zod'

export const PRODUCT_NAME_MAX = 120
export const PRODUCT_CATEGORY_NAME_MAX = 80
/** The most of one product a single cart line can hold. */
export const CART_QUANTITY_MAX = 999

export const productCategorySchema = z.object({
  name: z.string().trim().min(1, 'Name is required').max(PRODUCT_CATEGORY_NAME_MAX),
})

export const productSchema = z.object({
  name: z.string().trim().min(1, 'Name is required').max(PRODUCT_NAME_MAX),
  category_id: z.string().uuid('Choose a category'),
  sell_price: z.number().finite().min(0, 'Price must be 0 or greater'),
  // Optional: a gym may not know, or may not want to record, what an item cost.
  buy_price: z.number().finite().min(0, 'Price must be 0 or greater').nullable().optional(),
  // No minimum. Stock is allowed below zero: it means more was sold than was
  // counted, and the owner correcting it must be able to type what is there.
  stock: z.number().int('Stock must be a whole number').default(0),
  is_active: z.boolean().default(true),
})

export const productUpdateSchema = productSchema.partial()

export type ProductCategoryInput = z.infer<typeof productCategorySchema>
export type ProductInput = z.infer<typeof productSchema>
export type ProductUpdateInput = z.infer<typeof productUpdateSchema>
